import styled from '@emotion/styled';
import { doctors } from '../doctors';
import React from 'react';

export const DoctorPanelsStyled = styled.section`
    .doctor-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 48px;
    }
    h2 {
        color: ${({ theme }) => theme.colors.gray5};
        padding-bottom: 0px;
    }
    .image {
        width: 280px;
        height: 375px;
        background: url(image.png);
        border-radius: 15px;
    }
    @media ${({ theme }) => theme.device.laptop} {
        .doctor-container {
            flex-direction: row;
            align-items: flex-start;
            gap: 89px;
            margin-bottom: 128px;
            h2 {
                margin-bottom: 24px;
                width: 550px;
                margin-top: 0px;
            }
            .image {
                min-width: 325px;
                height: 435px;
            }
        }
    }
`;

export const DoctorPanels: React.FC = () => {
    return (
        <DoctorPanelsStyled>
            {doctors.map(doctor => {
                return (
                    <div className="doctor-container" key={doctor.name}>
                        {doctor.image()}
                        <div>
                            <h2 className="header-2 underline">{doctor.name}</h2>
                            <p>{doctor.bio()}</p>
                        </div>
                    </div>
                );
            })}
        </DoctorPanelsStyled>
    );
};
